import moment from 'moment';
import { useSelector } from 'react-redux';
import { TILES, CHART_OPTIONS, API_REGISTRY } from "../../app/config";
import { convertToPercent, round, capitalizeFirstLetter, deepCopy, calc, removeSpecialChar,
    removeCurrSymbol, getCorrectValue, getSampleSdYear } from "../../app/util"
import dataService from "../../services/data.service";
import TableToExcel from "@linways/table-to-excel";
import { setApiURLVars } from "../../actions/appstate";

function kFormatter(num, tofixed = 2) {
    //return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num)
    console.log("kFormatter", num);
    if (num >= 1000000000) {
        return (num / 1000000000).toFixed(tofixed).replace(/\.0$/, '') + 'G';
    }
    if (num >= 1000000) {
        return (num / 1000000).toFixed(tofixed).replace(/\.0$/, '') + 'M';
    }
    if (num >= 1000) {
        return (num / 1000).toFixed(tofixed).replace(/\.0$/, '') + 'K';
    }
    return num;
}

const chkValueNegative = (val, oriValue) => {
    let displayValue =
        oriValue >= 0 || typeof oriValue === "string"
            ? val
            : "(" + val.toString().replaceAll("-", "") + ")";
    return displayValue;
}



export const dataFormatMonthlyCard = (key, val, ui_state, tofixed = 2) => {
    let currency_symbol = (key && key === "Rooms") ? '' : ui_state.currency_symbol;
    var displayValue;
    val = parseFloat(val.toString().replaceAll(currency_symbol, ""));
    // alert(val);
    if(isNaN(val)){
        val = 0;
    }
    if (val > 999) {
        displayValue = currency_symbol + "" + kFormatter(val, tofixed);
    } else {
        displayValue = currency_symbol + "" + val.toLocaleString_();
    }
    return displayValue.toLocaleString_();
}


const dataFormat = (key, val, ui_state) => {

    let currency_symbol = ui_state.currency_symbol;
    var displayValue = val;
    //  if (key === "Rooms") {
    //     console.log(typeof displayValue," type of rooms",displayValue);
    // }
    if (!['_cap', '_vcap', '_vcapValue', '_vcapDiffers', '_vcapLabel'].includes(key)) {
        if (isNaN(val)) {
            val = 0;
        }
    }
    if (key === "Occ") {
        displayValue = (val) ? Number(val).toFixed(2) + "%" : val + "%";
    } else if (key === "Revenue") {
        displayValue = currency_symbol + Math.round(val).toLocaleString_();
    } else if (key === "Rooms") {
        displayValue = val.toLocaleString_();
    } else if (key === "SellRate") {
        displayValue = currency_symbol + parseInt(Math.round(val)).toLocaleString_();
    } else if (key === "ADR") {
        val = isFinite(val) ? val : 0;
        displayValue = currency_symbol + "" + val.toFixed(2).toLocaleString_();
    } 
    else if( ['_cap', '_vcap', '_vcapValue', '_vcapDiffers', '_vcapLabel'].includes(key)){
        displayValue = val;
    }
    else {
        displayValue = currency_symbol + "" + val.toFixed(2).toLocaleString_();
    }
    
    //key  not equal to _vcap and _vcapLabel
    if(!['_cap', '_vcap', '_vcapValue', '_vcapDiffers', '_vcapLabel'].includes(key)){
        displayValue = chkValueNegative(displayValue, val);
    }
    
    // return displayValue.toLocaleString_();
    return displayValue;
}

export function calculateMonthlyData(data, selectedMonth, ui_state, app_state) {
    const { dayDate } = app_state.workspace_controls;
    const startDate = moment(selectedMonth).startOf('month').format('YYYY-MM-DD');
    const endDate = moment(selectedMonth).endOf('month').format('YYYY-MM-DD');
    let monthData = moment(selectedMonth).format('MMM, YYYY');
    let noOfDays = moment(monthData).daysInMonth();
    let primary = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    let sdly = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    let sdly_actual = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    let sdtly = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    let sdtly_actual = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    let variance = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    let pickup = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    let aggregates = {
        sdly: { Rooms: 0, Occ: 0, ADR: 0, Revenue: 0 },
        sdly_actual: { Rooms: 0, Occ: 0, ADR: 0, Revenue: 0 },
        sdtly: { Rooms: 0, Occ: 0, ADR: 0, Revenue: 0 },
        sdtly_actual: { Rooms: 0, Occ: 0, ADR: 0, Revenue: 0 },
        primary: { Rooms: 0, Occ: 0, ADR: 0, Revenue: 0 },
        pickup: { Rooms: 0, Occ: 0, ADR: 0, Revenue: 0 }
    };
    let dayDateSdlyVar = (dayDate === 'day') ? "sdly" : "sdly"; // LRV-880 make else condition sdtly

    data.map((item) => {
        let yearMonth = new moment(endDate).format("YYYY-MM");
        let itemYearMonth = new moment(item.index.date).format("YYYY-MM");

        if (yearMonth === itemYearMonth) {
            primary.Occ = calc(primary.Occ, item.HotelTotal.primary.Occ, 3).add();
            primary.Rooms += (item.HotelTotal.primary.Rooms) ? parseInt(item.HotelTotal.primary.Rooms) : 0;
            primary.Revenue = calc(primary.Revenue, item.HotelTotal.primary.Revenue).add();
            primary.ADR += parseFloat(primary.Revenue / primary.Rooms);
            primary.RevPAR = calc(primary.RevPAR, item.HotelTotal.primary.RevPAR, 3).add();
            primary.SellRate = calc(primary.SellRate, item.HotelTotal.primary.SellRate, 4).add();

            sdly.Rooms += (item.HotelTotal.sdly.Rooms) ? parseInt(item.HotelTotal.sdly.Rooms) : 0;
            sdly.Occ = calc(sdly.Occ, item.HotelTotal.sdly.Occ, 3).add();
            sdly.ADR += parseFloat(item.HotelTotal.sdly.ADR);
            sdly.RevPAR += (item.HotelTotal.sdly.RevPAR) ? parseFloat(item.HotelTotal.sdly.RevPAR) : 0;
            sdly.SellRate += (item.HotelTotal.sdly.SellRate) ? parseFloat(item.HotelTotal.sdly.SellRate) : 0;
            sdly.Revenue += (item.HotelTotal.sdly.Revenue) ? parseFloat(item.HotelTotal.sdly.Revenue) : 0;

            sdly_actual.Rooms += parseInt(item.HotelTotal.sdly_actual.Rooms);
            sdly_actual.Occ = calc(sdly_actual.Occ, item.HotelTotal.sdly_actual.Occ, 3).add();
            sdly_actual.ADR += parseFloat(item.HotelTotal.sdly_actual.ADR);
            sdly_actual.RevPAR += parseFloat(item.HotelTotal.sdly_actual.RevPAR);
            sdly_actual.SellRate += parseFloat(item.HotelTotal.sdly_actual.SellRate);
            sdly_actual.Revenue += parseFloat(item.HotelTotal.sdly_actual.Revenue);


            if (dayDate === 'date') { // LRV-880 remove if condition 
                sdtly.Rooms += (item.HotelTotal.sdtly.Rooms) ? parseInt(item.HotelTotal.sdtly.Rooms) : 0;
                sdtly.Occ = calc(sdtly.Occ, item.HotelTotal.sdtly.Occ, 3).add();
                sdtly.ADR += parseFloat(item.HotelTotal.sdtly.ADR);
                sdtly.RevPAR += (item.HotelTotal.sdtly.RevPAR) ? parseFloat(item.HotelTotal.sdtly.RevPAR) : 0;
                sdtly.SellRate += (item.HotelTotal.sdtly.SellRate) ? parseFloat(item.HotelTotal.sdtly.SellRate) : 0;
                sdtly.Revenue += (item.HotelTotal.sdtly.Revenue) ? parseFloat(item.HotelTotal.sdtly.Revenue) : 0;

                sdtly_actual.Rooms += parseInt(item.HotelTotal.sdtly_actual.Rooms);
                sdtly_actual.Occ = calc(sdtly_actual.Occ, item.HotelTotal.sdtly_actual.Occ, 3).add();
                sdtly_actual.ADR += parseFloat(item.HotelTotal.sdtly_actual.ADR);
                sdtly_actual.RevPAR += parseFloat(item.HotelTotal.sdtly_actual.RevPAR);
                sdtly_actual.SellRate += parseFloat(item.HotelTotal.sdtly_actual.SellRate);
                sdtly_actual.Revenue += parseFloat(item.HotelTotal.sdtly_actual.Revenue);
            }
            variance.Rooms += parseInt(item.HotelTotal.primary.Rooms - item.HotelTotal[dayDateSdlyVar].Rooms);
            variance.Occ = calc([dayDateSdlyVar].Occ, item.HotelTotal[dayDateSdlyVar].Occ, 3).add();
            variance.ADR += parseFloat(primary.ADR - [dayDateSdlyVar].ADR);
            variance.RevPAR += parseFloat(item.HotelTotal[dayDateSdlyVar].RevPAR);
            variance.SellRate += parseFloat(item.HotelTotal[dayDateSdlyVar].SellRate);
            variance.Revenue += parseFloat(item.HotelTotal[dayDateSdlyVar].Revenue);

            pickup.Rooms += item.HotelTotal.pickup.Rooms;
            pickup.Revenue = calc(item.HotelTotal.pickup.Revenue, pickup.Revenue).add();
            pickup.Occ = calc(pickup.Occ, item.HotelTotal.pickup.Occ, 4).add();
            pickup.RevPAR = calc(pickup.RevPAR, item.HotelTotal.pickup.RevPAR, 5).add();
            pickup.SellRate = calc(pickup.SellRate, item.HotelTotal.pickup.SellRate).add();
        }
    });
    aggregates.primary.Occ = Math.round(primary.Occ * 10000 / noOfDays) / 10000;
    aggregates.primary.ADR = Math.round(primary.Revenue / primary.Rooms);
    aggregates.sdly.Occ = Math.round(sdly.Occ * 10000 / noOfDays) / 10000;
    aggregates.sdly.ADR = Math.round(sdly.Revenue / sdly.Rooms);
    aggregates.sdly_actual.Occ = Math.round(sdly_actual.Occ * 10000 / noOfDays) / 10000;
    aggregates.sdly_actual.ADR = Math.round(sdly_actual.Revenue / sdly_actual.Rooms);

    if (dayDate === 'date') { // LRV-880 remove if condition 
        aggregates.sdtly.Occ = Math.round(sdtly.Occ * 10000 / noOfDays) / 10000;
        aggregates.sdtly.ADR = Math.round(sdtly.Revenue / sdtly.Rooms);
        aggregates.sdtly_actual.Occ = Math.round(sdtly_actual.Occ * 10000 / noOfDays) / 10000;
        aggregates.sdtly_actual.ADR = Math.round(sdtly_actual.Revenue / sdtly_actual.Rooms);
    }

    aggregates.pickup.Rooms = calc(pickup.Rooms, primary.Rooms, 2).diff();
    aggregates.pickup.Revenue = Math.round(calc(pickup.Revenue, primary.Revenue, 2).diff());
    aggregates.pickup.ADR = aggregates.pickup.Revenue / aggregates.pickup.Rooms;
    aggregates.pickup.Occ = (calc(pickup.Occ, primary.Occ, 6).diff());
    aggregates.pickup.RevPAR = calc(pickup.RevPAR, primary.RevPAR, 2).diff();
    aggregates.pickup.SellRate = calc(pickup.SellRate, primary.SellRate, 4).diff();

    primary = {
        ...primary,
        Rooms: dataFormat("Rooms", primary.Rooms, ui_state),
        Occ: dataFormat("Occ", convertToPercent(primary.Occ / noOfDays), ui_state),
        ADR: isNaN(round(primary.Revenue / primary.Rooms)) ? "$0.00" :
            dataFormat("ADR", round(primary.Revenue / primary.Rooms), ui_state),
        RevPAR: dataFormat("RevPAR", round(primary.RevPAR / noOfDays), ui_state),
        Revenue: dataFormat("Revenue", Math.round(primary.Revenue), ui_state),
        SellRate: dataFormat("SellRate", Math.round(primary.SellRate / noOfDays), ui_state),
    };

    sdly = {
        ...sdly,
        //Original aggregates without formatting
        Rooms_o: sdly.Rooms,
        Occ_o: convertToPercent(sdly.Occ / noOfDays),
        ADR_o: isNaN(round(sdly.Revenue / sdly.Rooms)) ? 0 : round(sdly.Revenue / sdly.Rooms),

        Rooms: dataFormat("Rooms", sdly.Rooms, ui_state),
        Occ: dataFormat("Occ", convertToPercent(sdly.Occ / noOfDays), ui_state),
        ADR: isNaN(round(sdly.Revenue / sdly.Rooms)) ? "$0.00" : dataFormat("ADR", round(sdly.Revenue / sdly.Rooms), ui_state),
        RevPAR: dataFormat("RevPAR", round(sdly.RevPAR / noOfDays), ui_state),
        Revenue: dataFormat("Revenue", Math.round(sdly.Revenue), ui_state),
        SellRate: dataFormat("SellRate", Math.round(sdly.SellRate / noOfDays), ui_state),
    };
    sdly_actual = {
        ...sdly_actual,
        //Original aggregates without formatting
        Rooms: dataFormat("Rooms", sdly_actual.Rooms, ui_state),
        Occ: dataFormat("Occ", convertToPercent(sdly_actual.Occ / noOfDays), ui_state),
        ADR: isNaN(round(sdly_actual.Revenue / sdly_actual.Rooms)) ? "$0.00" :
            dataFormat("ADR", round(sdly_actual.Revenue / sdly_actual.Rooms), ui_state),
        RevPAR: dataFormat("RevPAR", round(sdly_actual.RevPAR / noOfDays), ui_state),
        Revenue: dataFormat("Revenue", Math.round(sdly_actual.Revenue), ui_state),
        SellRate: dataFormat("SellRate", Math.round(sdly_actual.SellRate / noOfDays), ui_state),
    };

    if (dayDate === 'date') { // LRV-880 remove if condition 

        sdtly = {
            ...sdtly,
            //Original aggregates without formatting
            Rooms_o: sdtly.Rooms,
            Occ_o: convertToPercent(sdtly.Occ / noOfDays),
            ADR_o: isNaN(round(sdtly.Revenue / sdtly.Rooms)) ? 0 : round(sdtly.Revenue / sdtly.Rooms),

            Rooms: dataFormat("Rooms", sdtly.Rooms, ui_state),
            Occ: dataFormat("Occ", convertToPercent(sdtly.Occ / noOfDays), ui_state),
            ADR: isNaN(round(sdtly.Revenue / sdtly.Rooms)) ? "$0.00" : dataFormat("ADR", round(sdtly.Revenue / sdtly.Rooms), ui_state),
            RevPAR: dataFormat("RevPAR", round(sdtly.RevPAR / noOfDays), ui_state),
            Revenue: dataFormat("Revenue", Math.round(sdtly.Revenue), ui_state),
            SellRate: dataFormat("SellRate", Math.round(sdtly.SellRate / noOfDays), ui_state),
        };
        sdtly_actual = {
            ...sdtly_actual,
            //Original aggregates without formatting
            Rooms: dataFormat("Rooms", sdtly_actual.Rooms, ui_state),
            Occ: dataFormat("Occ", convertToPercent(sdtly_actual.Occ / noOfDays), ui_state),
            ADR: isNaN(round(sdtly_actual.Revenue / sdtly_actual.Rooms)) ? "$0.00" :
                dataFormat("ADR", round(sdtly_actual.Revenue / sdtly_actual.Rooms), ui_state),
            RevPAR: dataFormat("RevPAR", round(sdtly_actual.RevPAR / noOfDays), ui_state),
            Revenue: dataFormat("Revenue", Math.round(sdtly_actual.Revenue), ui_state),
            SellRate: dataFormat("SellRate", Math.round(sdtly_actual.SellRate / noOfDays), ui_state),
        };
    }
    let dayDateSdly = (dayDate === 'day') ? sdly : sdly; // LRV-880 make else condition sdtly
    let varAdr = removeCurrSymbol(primary.ADR, ui_state.currency_symbol) - removeCurrSymbol(dayDateSdly['ADR'], ui_state.currency_symbol);
    let varOcc = parseFloat((primary.Occ).toString().replaceAll("%", "")) - parseFloat((dayDateSdly['Occ']).toString().replaceAll("%", ""));
    let varRevPar = removeCurrSymbol(primary.RevPAR, ui_state.currency_symbol) - removeCurrSymbol(dayDateSdly['RevPAR'], ui_state.currency_symbol);
    let varRevenue = removeSpecialChar(primary.Revenue, ui_state.currency_symbol) - removeSpecialChar(dayDateSdly['Revenue'], ui_state.currency_symbol);
    let sdlySellRate = (isNaN(removeCurrSymbol(dayDateSdly['SellRate'], ui_state.currency_symbol))) ? 0 : removeCurrSymbol(dayDateSdly['SellRate'], ui_state.currency_symbol);
    let varSellRate = removeSpecialChar(primary.SellRate, ui_state.currency_symbol) - removeSpecialChar(dayDateSdly['SellRate'], ui_state.currency_symbol);

    variance = {
        ...variance,
        Rooms: dataFormat("Rooms", variance.Rooms, ui_state),
        Occ: dataFormat("Occ", round(varOcc), ui_state),
        ADR: isNaN(varAdr) ? "$0.00" : dataFormat("ADR", round(varAdr), ui_state),
        RevPAR: dataFormat("RevPAR", round(varRevPar), ui_state),
        Revenue: dataFormat("Revenue", round(varRevenue), ui_state),
        SellRate: dataFormat("SellRate", round(varSellRate), ui_state)
    };
    // debugger;
    pickup = {
        ...pickup,
        Revenue: dataFormat("Revenue", aggregates.pickup.Revenue, ui_state),
        Rooms: dataFormat("Rooms", aggregates.pickup.Rooms, ui_state),
        Occ: dataFormat("Occ", convertToPercent((aggregates.pickup.Occ / noOfDays)).toFixed(2), ui_state),
        ADR: isNaN(round(aggregates.pickup.ADR)) ? "$0.00" :
            dataFormat("ADR", round(aggregates.pickup.ADR), ui_state),
        RevPAR: dataFormat("RevPAR", round(aggregates.pickup.RevPAR / noOfDays), ui_state),
        SellRate: dataFormat("SellRate", (round(aggregates.pickup.SellRate) / noOfDays), ui_state),
    };

    let dataObj = { monthData, primary, sdly, sdtly, variance, pickup, aggregates };
    return dataObj;
}


export function getMonthlyData(data, ui_state, app_state) {
    let currentDate = moment(app_state.as_of_date).format('YYYY-MM');
    let selectedMonth;
    let dataSetup = [];
    for (let i = 0; i < 12; i++) {
        selectedMonth = moment(currentDate).add(i, "M").format('YYYY-MM-DD');
        dataSetup.push(calculateMonthlyData(data, selectedMonth, ui_state, app_state));
    }
    // debugger;
    return dataSetup;
}
export function processMonthlyPropertyData(data, pickupData, currency_symbol, dayDate, showIndicator = false, showVariableCapacity = false) {
    const dataLayout = {
        columns: ["monthData", "primary",
            "sdly", "sdtly", "variance", "pickup", "aggregates", "forecast"],
        standardkeys: [
            { key: "Rooms", format: "number" },
            { key: "Occ", format: "percent" },
            { key: "ADR", format: "currency" },
            { key: "RevPAR", format: "currency" },
            { key: "SellRate", format: "currency" },
            { key: "Revenue", format: "currency" },
        ]
    }
    const variableCapacityKeys = showIndicator ? [
        { key: "_cap", format: "number" },
        { key: "_vcap", format: "number" },
        { key: "_vcapValue", format: "number" },
        { key: "_vcapDiffers", format: "boolean" },
        { key: "_vcapLabel", format: "string" }
    ]:[];
    // "Rooms_o":2600,
    //      "Occ_o":59.78,
    //      "ADR_o":233.53
    let dataSetup = []
    let sdlyActuals = (dayDate === 'day') ? "sdly_actual" : "sdly_actual"; 
    let dayDateSdly = (dayDate === 'day') ? "sdly" : "sdly";
    data.forEach(item => {
        const dataPoint = { };
        let date = item.index.date;
        let pickupItem = pickupData.find(i => i.index.date === date);
        
        if(showIndicator && item.hotel_total){
            ["sdly","primary"].forEach(col => {
                //code for ty item data update
                let cap = item.hotel_total[col].Capacity;
                let vCap = item.hotel_total[col].VCapacity;
                let vcapValue = showVariableCapacity ? item.hotel_total[col].VCapacity ? item.hotel_total[col].VCapacity : item.hotel_total[col].Capacity : item.hotel_total[col].Capacity;
                let vcapDiffers = item.hotel_total[col].VCapacity ? item.hotel_total[col].VCapacity !== item.hotel_total[col].Capacity ? true : false : false;
                let vcapLabel = showVariableCapacity ? item.hotel_total[col].VCapacity ? 'Variable Capacity' : 'Capacity' : 'Capacity';
                
                if (vcapDiffers) {
                    item.hotel_total[col]._cap = cap;
                    item.hotel_total[col]._vcap = vCap;
                    item.hotel_total[col]._vcapValue = vcapValue;
                    item.hotel_total[col]._vcapDiffers = vcapDiffers;
                    item.hotel_total[col]._vcapLabel = vcapLabel;

                    if(item.hotel_total[col].VCapacity && showVariableCapacity){
                        item.hotel_total[col].Occ = item.hotel_total[col].Rooms / item.hotel_total[col].VCapacity;
                        item.hotel_total[col].RevPAR = item.hotel_total[col].Revenue / item.hotel_total[col].VCapacity;
                    }
                    else{
                        item.hotel_total[col].Occ = item.hotel_total[col].Rooms / item.hotel_total[col].Capacity;
                        item.hotel_total[col].RevPAR = item.hotel_total[col].Revenue / item.hotel_total[col].Capacity;
                    }
                }

                // code for pickupItem data update
                if(col === "primary" && pickupItem && pickupItem.hotel_total){

                    let pCap = pickupItem.hotel_total[col].Capacity;
                    let pVCap = pickupItem.hotel_total[col].VCapacity;
                    let pVCapValue = showVariableCapacity ? pickupItem.hotel_total[col].VCapacity ? pickupItem.hotel_total[col].VCapacity : pickupItem.hotel_total[col].Capacity : pickupItem.hotel_total[col].Capacity;
                    let pVCapDiffers = pickupItem.hotel_total[col].VCapacity ? pickupItem.hotel_total[col].VCapacity !== pickupItem.hotel_total[col].Capacity ? true : false : false;
                    let pVCapLabel = showVariableCapacity ? pickupItem.hotel_total[col].VCapacity ? 'Variable Capacity' : 'Capacity' : 'Capacity';

                    if (pVCapDiffers) {
                        pickupItem.hotel_total[col]._cap = pCap;
                        pickupItem.hotel_total[col]._vcap = pVCap;
                        pickupItem.hotel_total[col]._vcapValue = pVCapValue;
                        pickupItem.hotel_total[col]._vcapDiffers = pVCapDiffers;
                        pickupItem.hotel_total[col]._vcapLabel = pVCapLabel;

                        if(pickupItem.hotel_total[col].VCapacity && showVariableCapacity){
                            pickupItem.hotel_total[col].Occ = pickupItem.hotel_total[col].Rooms / pickupItem.hotel_total[col].VCapacity;
                            pickupItem.hotel_total[col].RevPAR = pickupItem.hotel_total[col].Revenue / pickupItem.hotel_total[col].VCapacity;
                        }else{
                            pickupItem.hotel_total[col].Occ = pickupItem.hotel_total[col].Rooms / pickupItem.hotel_total[col].Capacity;
                            pickupItem.hotel_total[col].RevPAR = pickupItem.hotel_total[col].Revenue / pickupItem.hotel_total[col].Capacity;
                        }
                    }

                }
            })
        }
        



        dataLayout.columns.forEach(col => {
            if (col === "monthData") {
                dataPoint["monthData"] = moment(date).format("MMM, YYYY")
            }
            else if (col === "aggregates") {
                dataPoint[col] = {};
                // ["sdly", "sdly_actual", "sdtly", "sdtly_actuals", "primary", "pickup"].forEach(aggCol => {
                    // LRV-880 Enable above line 
                ["sdly", "sdly_actual", "primary", "pickup"].forEach(aggCol => {
                    dataPoint["aggregates"][aggCol] = {};
                    dataLayout.standardkeys.forEach(({ key, format }) => {
                        let value = "";
                        if (aggCol === "pickup" && pickupItem) {
                            if (key === "ADR") {
                                value = (item.hotel_total["primary"]["Revenue"] - pickupItem.hotel_total["primary"]["Revenue"]) / (item.hotel_total["primary"]["Rooms"] - pickupItem.hotel_total["primary"]["Rooms"])
                            } else {
                                value = item.hotel_total["primary"][key] - pickupItem.hotel_total["primary"][key];
                            }
                        } else if (aggCol === "sdly_actual" && pickupItem) {
                            value = pickupItem.hotel_total[sdlyActuals][key];
                        }
                        else if (item.hotel_total[aggCol] && item.hotel_total[aggCol][key]) {
                            value = item.hotel_total[aggCol][key];
                        }
                        dataPoint["aggregates"][aggCol][key] = value;
                    })
                })
            }
            else if (col === "forecast") {
                dataPoint["forecast"] = {};
                const forecastPrimary = item.hotel_total ? item.hotel_total.primary : null;
                const forecastVCap = forecastPrimary ? (forecastPrimary.VCapacity || forecastPrimary.Capacity) : null;
                const useForecastVarCap = showIndicator && showVariableCapacity && forecastVCap;
                dataLayout.standardkeys.forEach(({ key, format }) => {
                    if (key !== "SellRate") {
                        let value = "";

                        if (useForecastVarCap && key === "Occ") {
                            value = item.total_forecast.rooms_forecast / forecastVCap;
                        } else if (useForecastVarCap && key === "RevPAR") {
                            value = item.total_forecast.revenue_forecast / forecastVCap;
                        } else {
                            value = item.total_forecast[key.toLowerCase() + "_forecast"];
                        }

                        if (value !== "") {
                            if (format === "percent") {
                                value = convertToPercent(value);
                            }
                            value = dataFormat(key, value, { currency_symbol })
                        }
                        dataPoint[col][key] = value;
                    }
                })
            }
            else {
                dataPoint[col] = {};
                const standardKeys = ["sdly", "primary", "pickup"].includes(col) ? [...dataLayout.standardkeys, ...variableCapacityKeys] : dataLayout.standardkeys;
                standardKeys.forEach(({ key, format }) => {
                    let value = "";

                    if (col === "pickup" && pickupItem) {
                        if (key === "ADR") {
                            value = (item.hotel_total["primary"]["Revenue"] - pickupItem.hotel_total["primary"]["Revenue"]) / (item.hotel_total["primary"]["Rooms"] - pickupItem.hotel_total["primary"]["Rooms"])
                        } 
                        else if (key === "_cap" || key === "_vcap" || key === "_vcapValue" ) {
                            value = item.hotel_total["primary"][key] - pickupItem.hotel_total["primary"][key];
                        }
                        else if (key === "_vcapLabel" || key === "_vcapDiffers") {
                            value = pickupItem.hotel_total["primary"][key];
                        }
                        else {
                            value = item.hotel_total["primary"][key] - pickupItem.hotel_total["primary"][key];
                        }
                    } else if (col === "variance" && pickupItem) {
                        value = item.hotel_total["primary"][key] - item.hotel_total[dayDateSdly][key]
                    } else if (item.hotel_total[col] && item.hotel_total[col][key]) {
                        value = item.hotel_total[col][key];
                    }

                    if (value !== "") {
                        if (format === "percent") {
                            value = convertToPercent(value);
                        }
                        value = dataFormat(key, value, { currency_symbol })
                    }
                    dataPoint[col][key] = value;
                })
            }
        })
        dataSetup.push(dataPoint)
    })
    return dataSetup
}
export function getTotalRowData(data,pickupData, currency_symbol, type ){
    const dataLayout = {
        columns: ["monthData", "primary",
            "sdly", "variance", "pickup", "aggregates", "forecast"],
        standardkeys: [
            { key: "Rooms", format: "number" },
            { key: "Occ", format: "percent" },
            { key: "RevPAR", format: "currency" },
            { key: "SellRate", format: "currency" },
            { key: "Revenue", format: "currency" },
            { key: "ADR", format: "currency" },

        ]
    };
    const totalDataRow = {};
    let sdlyActuals = (type === "market") ? "sdly_actuals" :"sdly_actual";
    let mainKey = (type === "market") ? "market_total" :"hotel_total";
    dataLayout.columns.forEach(col=>{
        if(col === "aggregates"){
            totalDataRow["aggregates"]={
                pickup:{},
                sdly:{},
                primary:{},
                
            }
            totalDataRow["aggregates"][sdlyActuals]={};
            dataLayout.standardkeys.forEach(({key,format})=>{
                totalDataRow["aggregates"]["pickup"][key]=0;
                totalDataRow["aggregates"]["sdly"][key]=0;
                totalDataRow["aggregates"]["primary"][key]=0;
                totalDataRow["aggregates"][sdlyActuals][key]=0;

            })
        }else if(col === "monthData"){
            totalDataRow["monthData"]="Total";
        }else {
            totalDataRow[col]={};
            dataLayout.standardkeys.forEach(({key,format})=>{
                totalDataRow[col][key]=0;
            })
        }
    });
    data.forEach((item,index)=>{
        let pickupItem = pickupData.find(i => i.index.date === item.index.date);
        dataLayout.columns.forEach(col=>{
            dataLayout.standardkeys.forEach(({key, format})=>{
                if(col === "aggregates"){
                    Object.keys(totalDataRow["aggregates"]).forEach(aggregatekey=>{
                        if(key === "ADR" ){
                            totalDataRow["aggregates"][aggregatekey]["ADR"]=(totalDataRow["aggregates"][aggregatekey]["Revenue"] / totalDataRow["aggregates"][aggregatekey]["Rooms"]);
                        }else {
                            if(aggregatekey === "pickup"){
                                totalDataRow["aggregates"][aggregatekey][key] += (item[mainKey]["primary"][key] - pickupItem[mainKey]["primary"][key]);
                            }else {
                                totalDataRow["aggregates"][aggregatekey][key]+=item[mainKey][aggregatekey][key];

                            }
                        }
                    })
                   
                }
                else if(col !== "monthData") {
                   
                    if(col === "forecast"){
                        if(key === "ADR"){
                            totalDataRow[col][key]=totalDataRow.forecast.Revenue/totalDataRow.forecast.Rooms;
                        }
                        if(key === "Occ"){
                            totalDataRow[col][key]+=item["total_forecast"]["occ_forecast"];
                        }
                        if(key === "RevPar"){
                            totalDataRow[col][key]+=item[mainKey]["revpar_forecast"];
                        }
                        if(key === "Revenue"){
                            totalDataRow[col][key]+=item[mainKey]["revenue_forecast"];
                        }
                        if(key === "Rooms"){
                            totalDataRow[col][key]+=item[mainKey]["rooms_forecast"];
                        }
                       
                    }
                    else if(col === "variance") {
                        if(key === "ADR" ){
                            totalDataRow[col]["ADR"]=  totalDataRow["primary"]["ADR"]- totalDataRow["sdly"]["ADR"];
                        }else {
                            totalDataRow[col][key] += item[mainKey]["primary"][key] - item[mainKey]["sdly"][key]

                        }
                    }
                    else if(col === "pickup"){
                
                        if (key  === "ADR") {
                            totalDataRow[col]["ADR"] = (totalDataRow["pickup"]["Revenue"]) / (totalDataRow["pickup"]["Rooms"])
                        } else {
                            if(!pickupItem){
                                pickupItem={};
                                pickupItem[mainKey]={"primary":{}};
                            }
                            let sellRateNotAvial=false;
                            if(!pickupItem[mainKey]["primary"][key]){
                                pickupItem[mainKey]["primary"][key]=0;
                                if(key === "SellRate"){
                                    sellRateNotAvial = true;
                                }
                            }
                            if(!sellRateNotAvial){
                                totalDataRow[col][key] += (item[mainKey]["primary"][key] - pickupItem[mainKey]["primary"][key]);
                            }
                        }
                    }
                    else {
                        if(key === "ADR" ){
                            totalDataRow[col]["ADR"]=(totalDataRow[col]["Revenue"] / totalDataRow[col]["Rooms"]);
                        }else{
                            totalDataRow[col][key]+=item[mainKey][col][key];
                        }
                    }
                    
                }
         })
        })
       
    });
    dataLayout.columns.forEach(col=>{
        dataLayout.standardkeys.forEach(({key, format})=>{
            if(col === "aggregates"){
                Object.keys(totalDataRow["aggregates"]).forEach(aggregatekey=>{
                    if(key === "RevPAR" || key === "SellRate" || key === "Occ"){
                        totalDataRow["aggregates"][aggregatekey][key] = (totalDataRow["aggregates"][aggregatekey][key] / data.length);
                    }
                })
            }else if(col !== "monthData") {
                if(key === "RevPAR" || key === "SellRate" || key === "Occ"){
                    totalDataRow[col][key] = (totalDataRow[col][key] / data.length);
                }
                if (totalDataRow[col][key] !== "") {
                    if (format === "percent") {
                        totalDataRow[col][key] = convertToPercent(totalDataRow[col][key]);
                    }
                    totalDataRow[col][key] = dataFormat(key, totalDataRow[col][key], { currency_symbol })
                }
            }
        })
    });
    console.log("totalDataRow",totalDataRow)
    return totalDataRow;

}
export function processMonthlyMarketData(data, pickupData, currency_symbol, dayDate) {
    const dataLayout = {
        columns: ["monthData", "primary",
            "sdly", "sdtly", "variance", "pickup", "aggregates", "forecast"],
        standardkeys: [
            { key: "Rooms", format: "number" },
            { key: "Occ", format: "percent" },
            { key: "ADR", format: "currency" },
            { key: "RevPAR", format: "currency" },
            { key: "SellRate", format: "currency" },
            { key: "Revenue", format: "currency" },
        ]
    }

    // "Rooms_o":2600,
    //      "Occ_o":59.78,
    //      "ADR_o":233.53
    let dataSetup = []
    let sdlyActuals = (dayDate === 'day') ? "sdly_actuals" : "sdly_actuals"; // LRV-880 make else condition sdtly
    let dayDateSdly = (dayDate === 'day') ? "sdly" : "sdly";// LRV-880 make else condition sdtly
    data.forEach(item => {
        const dataPoint = {

        };
        let date = item.index.date;
        let pickupItem = pickupData.find(i => i.index.date === date);
        dataLayout.columns.forEach(col => {
            if (col === "monthData") {
                dataPoint["monthData"] = moment(date).format("MMM, YYYY")
            }
            else if (col === "aggregates") {
                dataPoint[col] = {};
                // ["sdly", "sdly_actual", "sdtly", "sdtly_actuals", "primary", "pickup"].forEach(aggCol => {
                    // LRV-880 Enable above line 
                ["sdly", "sdly_actual", "primary", "pickup"].forEach(aggCol => {
                    dataPoint["aggregates"][aggCol] = {};
                    dataLayout.standardkeys.forEach(({ key, format }) => {
                        let value = "";
                        if (aggCol === "pickup" && pickupItem) {
                            if (key === "ADR") {
                                value = (item.market_total["primary"]["Revenue"] - pickupItem.market_total["primary"]["Revenue"]) / (item.market_total["primary"]["Rooms"] - pickupItem.market_total["primary"]["Rooms"])
                            } else {
                                value = item.market_total["primary"][key] - pickupItem.market_total["primary"][key];
                            }
                        } else if (aggCol === "sdly_actual" && pickupItem) {
                            value = pickupItem.market_total[sdlyActuals][key];
                        }
                        else if (item.market_total[aggCol] && item.market_total[aggCol][key]) {
                            value = item.market_total[aggCol][key];
                        }
                        dataPoint["aggregates"][aggCol][key] = value;
                    })
                })
            }
            else if (col === "forecast") {
                dataPoint["forecast"] = {};
                dataLayout.standardkeys.forEach(({ key, format }) => {
                    if (key !== "SellRate") {
                        let value = "";

                        value = item.total_forecast[key.toLowerCase() + "_forecast"];

                        if (value !== "") {
                            if (format === "percent") {
                                value = convertToPercent(value);
                            }
                            value = dataFormat(key, value, { currency_symbol })
                        }
                        dataPoint[col][key] = value;
                    }
                })
            }
            else {
                dataPoint[col] = {};
                dataLayout.standardkeys.forEach(({ key, format }) => {
                    let value = "";

                    if (col === "pickup" && pickupItem) {
                        if (key === "ADR") {
                            value = (item.market_total["primary"]["Revenue"] - pickupItem.market_total["primary"]["Revenue"]) / (item.market_total["primary"]["Rooms"] - pickupItem.market_total["primary"]["Rooms"])
                        } else {
                            value = item.market_total["primary"][key] - pickupItem.market_total["primary"][key];
                        }
                    } else if (col === "variance" && pickupItem) {
                        value = item.market_total["primary"][key] - item.market_total[dayDateSdly][key]
                    } else if (item.market_total[col] && item.market_total[col][key]) {
                        value = item.market_total[col][key];
                    }

                    if (value !== "") {
                        if (format === "percent") {
                            value = convertToPercent(value);
                        }
                        value = dataFormat(key, value, { currency_symbol })
                    }
                    dataPoint[col][key] = value;
                })
            }
        })
        dataSetup.push(dataPoint)
    })
    return dataSetup
}


export function calculateMonthlyForecastData(data, selectedMonth, ui_state) {
    const startDate = moment(selectedMonth).startOf('month').format('YYYY-MM-DD');
    const endDate = moment(selectedMonth).endOf('month').format('YYYY-MM-DD');
    let monthData = moment(selectedMonth).format('MMM, YYYY');
    let noOfDays = moment(monthData).daysInMonth();

    let forecast = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, SellRate: 0, Revenue: 0 };
    data.data.map((item, index) => {
        if (moment(item.stay_date) >= moment(startDate) && moment(item.stay_date) <= moment(endDate)) {
            forecast.Rooms += parseInt(item.predicted_total_cons_rooms);
            forecast.Occ += parseFloat(item.predicted_total_cons_occ);
            forecast.ADR += parseFloat(item.predicted_total_cons_adr);
            forecast.RevPAR += parseFloat(item.predicted_total_cons_revpar);
            forecast.Revenue += parseFloat(item.predicted_total_cons_revenue);
        }
    })

    forecast = {
        ...forecast,
        Rooms: dataFormat("Rooms", forecast.Rooms, ui_state),
        Occ: dataFormat("Occ", convertToPercent(forecast.Occ / noOfDays), ui_state),
        ADR: isNaN(round(forecast.Revenue / forecast.Rooms)) ? "$0.00" :
            dataFormat("ADR", round(forecast.Revenue / forecast.Rooms), ui_state),
        RevPAR: dataFormat("RevPAR", round(forecast.RevPAR / noOfDays), ui_state),
        Revenue: dataFormat("Revenue", Math.round(forecast.Revenue), ui_state),
    };

    let dataObj = { forecast };
    // console.log("Forecast final data is =>",dataObj);

    return dataObj;
}

export function getMonthlyForecastData(data, ui_state, app_state) {
    let currentDate = moment(app_state.as_of_date).format('YYYY-MM');
    let selectedMonth;
    let dataSetup = [];
    for (let i = 0; i < 12; i++) {
        selectedMonth = moment(currentDate).add(i, "M").format('YYYY-MM-DD');
        dataSetup.push(calculateMonthlyForecastData(data, selectedMonth, ui_state));
    }
    return dataSetup;
}


// function to get 365 data from the api
export const getData365 = async ({ primary_stay_range, date_from, date_until, as_of_date, property_id, workspace_controls, removeCompId , customRange}, seriesID) => {
    let rangeFromDate = date_from;
    
    let rangeUntilDate = moment(rangeFromDate).add(1, "year").format('YYYY-MM-DD');
    
    if(customRange){
        rangeUntilDate= date_until
    }
    console.log("rangeUntilDate", rangeUntilDate)
    let selectedAPI = API_REGISTRY[seriesID];

    let sd_year = getSampleSdYear(primary_stay_range, workspace_controls);
    let varMaps = {
        pid: property_id,
        pickUpDays: workspace_controls.pickUpDays,
        sdYear: sd_year,//workspace_controls.sdYear,
        fromDate: rangeFromDate,
        date_from: rangeFromDate,
        rangeFromDate: rangeFromDate,
        removeCompId: removeCompId,
        rangeUntilDate: rangeUntilDate,
        date_until: rangeUntilDate,
        toDate: rangeUntilDate,
        asof_date: as_of_date,
        asOfDate: as_of_date,
        pid: property_id,
        timestamp: Math.random()
    };
    let payload = {
        method: "GET",
    };
    if (seriesID === "Compset") {
        payload.api = `rms/properties/compset/${varMaps.pid}/?removeCompId=true&asOfDate=${varMaps.asOfDate}&fromDate=${varMaps.date_from}&toDate=${varMaps.date_until}&time=${varMaps.timestamp}`
    }
    else {
        payload.api = setApiURLVars(selectedAPI.uri, varMaps);

    }

    return dataService.getData({ api: payload.api, request: payload, });
    //return payload;

}

/** function to get budget monthly data */
export function getMonthlyBudgetData(budgetMonthlyData, app_state, ui_state, useVarCapacity = false) {
    // debugger;
    let as_of_date = app_state.as_of_date;
    let startDate = moment(as_of_date).format('YYYY-MM-01');
    let endDate = moment(startDate).endOf('month').format('YYYY-MM-DD');
    let noOfDays = moment(endDate).daysInMonth();

    let firstMonthData = budgetMonthlyData.data.slice(0, noOfDays);
    let budgetFirstMonth = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, Revenue: 0, VCapacity: 0 };
    firstMonthData.map((item, index) => {
        budgetFirstMonth.Rooms += getCorrectValue(item['budgetDataset']['Rooms']);
        budgetFirstMonth.Occ += getCorrectValue(item['budgetDataset']['Occ%']);
        budgetFirstMonth.ADR += getCorrectValue(item['budgetDataset']['ADR']);
        budgetFirstMonth.RevPAR += getCorrectValue(item['budgetDataset']['RevPAR']);
        budgetFirstMonth.Revenue += getCorrectValue(item['budgetDataset']['Revenue']);
        budgetFirstMonth.VCapacity += getCorrectValue(item['budgetDataset']['VCapacity'] || item['budgetDataset']['Capacity']);
    })
    const useVarCapFirstMonth = useVarCapacity && budgetFirstMonth.VCapacity;
    budgetFirstMonth = {
        ...budgetFirstMonth,
        Rooms: dataFormat("Rooms", budgetFirstMonth.Rooms, ui_state),
        Occ: dataFormat("Occ", useVarCapFirstMonth ? convertToPercent(budgetFirstMonth.Rooms / budgetFirstMonth.VCapacity) : (budgetFirstMonth.Occ / noOfDays), ui_state),
        ADR: isNaN(round(budgetFirstMonth.Revenue / budgetFirstMonth.Rooms)) ? "0.00" :
            dataFormat("ADR", round(budgetFirstMonth.Revenue / budgetFirstMonth.Rooms), ui_state),
        RevPAR: dataFormat("RevPAR", useVarCapFirstMonth ? (budgetFirstMonth.Revenue / budgetFirstMonth.VCapacity) : round(budgetFirstMonth.RevPAR / noOfDays), ui_state),
        Revenue: dataFormat("Revenue", Math.round(budgetFirstMonth.Revenue), ui_state),
    };

    let nextMonth = moment(startDate).startOf('month').add(1, "month").format('YYYY-MM-DD');
    let nextMonthEndDate = moment(nextMonth).endOf('month').format('YYYY-MM-DD');
    let noOfDays_nextMonth = moment(nextMonthEndDate).daysInMonth();

    let nextMonthData = budgetMonthlyData.data.filter((item) => {
        if (moment(item.index.date).isBetween(nextMonth, nextMonthEndDate, undefined, '[]')) {
            return true;
        }
    });
    let budgetNextMonth = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, Revenue: 0, VCapacity: 0 };
    nextMonthData.map((item, index) => {
        budgetNextMonth.Rooms += getCorrectValue(item['budgetDataset']['Rooms']);
        budgetNextMonth.Occ += getCorrectValue(item['budgetDataset']['Occ%']);
        budgetNextMonth.ADR += getCorrectValue(item['budgetDataset']['ADR']);
        budgetNextMonth.RevPAR += getCorrectValue(item['budgetDataset']['RevPAR']);
        budgetNextMonth.Revenue += getCorrectValue(item['budgetDataset']['Revenue']);
        budgetNextMonth.VCapacity += getCorrectValue(item['budgetDataset']['VCapacity'] || item['budgetDataset']['Capacity']);
    })
    const useVarCapNextMonth = useVarCapacity && budgetNextMonth.VCapacity;
    budgetNextMonth = {
        ...budgetNextMonth,
        Rooms: dataFormat("Rooms", budgetNextMonth.Rooms, ui_state),
        Occ: dataFormat("Occ", useVarCapNextMonth ? convertToPercent(budgetNextMonth.Rooms / budgetNextMonth.VCapacity) : (budgetNextMonth.Occ / noOfDays_nextMonth), ui_state),

        ADR: isNaN(round(budgetNextMonth.Revenue / budgetNextMonth.Rooms)) ? "0.00" :
            dataFormat("ADR", round(budgetNextMonth.Revenue / budgetNextMonth.Rooms), ui_state),
        RevPAR: dataFormat("RevPAR", useVarCapNextMonth ? (budgetNextMonth.Revenue / budgetNextMonth.VCapacity) : round(budgetNextMonth.RevPAR / noOfDays_nextMonth), ui_state),
        Revenue: dataFormat("Revenue", Math.round(budgetNextMonth.Revenue), ui_state),
    };

    let farMonth = moment(startDate).startOf('month').add(2, "month").format('YYYY-MM-DD');
    let farMonthEndDate = moment(farMonth).endOf('month').format('YYYY-MM-DD');
    let noOfDays_farMonth = moment(farMonthEndDate).daysInMonth();

    let farMonthData = budgetMonthlyData.data.filter((item) => {
        if (moment(item.index.date).isBetween(farMonth, farMonthEndDate, undefined, '[]')) {
            return true;
        }
    });
    let budgetFarMonth = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, Revenue: 0, VCapacity: 0 };
    farMonthData.map((item, index) => {
        budgetFarMonth.Rooms += getCorrectValue(item['budgetDataset']['Rooms']);
        budgetFarMonth.Occ += getCorrectValue(item['budgetDataset']['Occ%']);
        budgetFarMonth.ADR += getCorrectValue(item['budgetDataset']['ADR']);
        budgetFarMonth.RevPAR += getCorrectValue(item['budgetDataset']['RevPAR']);
        budgetFarMonth.Revenue += getCorrectValue(item['budgetDataset']['Revenue']);
        budgetFarMonth.VCapacity += getCorrectValue(item['budgetDataset']['VCapacity'] || item['budgetDataset']['Capacity']);
    })
    const useVarCapFarMonth = useVarCapacity && budgetFarMonth.VCapacity;
    budgetFarMonth = {
        ...budgetFarMonth,
        Rooms: dataFormat("Rooms", budgetFarMonth.Rooms, ui_state),
        Occ: dataFormat("Occ", useVarCapFarMonth ? convertToPercent(budgetFarMonth.Rooms / budgetFarMonth.VCapacity) : (budgetFarMonth.Occ / noOfDays_farMonth), ui_state),

        ADR: isNaN(round(budgetFarMonth.Revenue / budgetFarMonth.Rooms)) ? "0.00" :
            dataFormat("ADR", round(budgetFarMonth.Revenue / budgetFarMonth.Rooms), ui_state),
        RevPAR: dataFormat("RevPAR", useVarCapFarMonth ? (budgetFarMonth.Revenue / budgetFarMonth.VCapacity) : round(budgetFarMonth.RevPAR / noOfDays_farMonth), ui_state),
        Revenue: dataFormat("Revenue", Math.round(budgetFarMonth.Revenue), ui_state),
    };
    let dataObj = [budgetFirstMonth, budgetNextMonth, budgetFarMonth];
    return dataObj;
}
/** end  */

export function calForeCastData(OtbFullData, foreCastData, app_state, ui_state) {
    console.log("both data ");

    console.log(foreCastData);
    let otbData = [];
    let otb = OtbFullData;
    let as_of_date = app_state.as_of_date;
    let startDate = moment(as_of_date).format('YYYY-MM-01');
    let endDate = moment(startDate).endOf('month').format('YYYY-MM-DD');
    let noOfDays = moment(endDate).daysInMonth();


    let beforeDatesCount = Math.abs(moment.duration(moment(startDate).diff(moment(as_of_date))).asDays());

    const getPastOtbData = otb.slice(0, beforeDatesCount);
    for (let n = 0; n < getPastOtbData.length; n++) {
        otbData.push({
            stay_date: getPastOtbData[n]['index'].date,
            predicted_total_cons_rooms: getPastOtbData[n]['HotelTotal']['primary'].Rooms,
            predicted_total_cons_adr: getPastOtbData[n]['HotelTotal']['primary'].ADR,
            predicted_total_cons_revpar: getPastOtbData[n]['HotelTotal']['primary'].RevPAR,
            predicted_total_cons_revenue: getPastOtbData[n]['HotelTotal']['primary'].Revenue,
            predicted_total_cons_occ: getPastOtbData[n]['HotelTotal']['primary'].Occ
        })
    }
    console.log("foreCastData.data= ", foreCastData.data);
    // debugger;
    let m = Math.abs(moment.duration(moment(as_of_date).diff(moment(endDate))).asDays()) + 1;
    let forcastRemaingData = foreCastData.data.data.slice(0, m);

    let firstMonthData = otbData.concat(forcastRemaingData);
    let forecastFirstMonth = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, Revenue: 0 };
    firstMonthData.map((item, index) => {
        forecastFirstMonth.Rooms += getCorrectValue(item.predicted_total_cons_rooms);
        forecastFirstMonth.Occ += getCorrectValue(item.predicted_total_cons_occ);
        forecastFirstMonth.ADR += getCorrectValue(item.predicted_total_cons_adr);
        forecastFirstMonth.RevPAR += getCorrectValue(item.predicted_total_cons_revpar);
        forecastFirstMonth.Revenue += getCorrectValue(item.predicted_total_cons_revenue);
    })

    forecastFirstMonth = {
        ...forecastFirstMonth,
        Rooms: dataFormat("Rooms", forecastFirstMonth.Rooms, ui_state),
        Occ: dataFormat("Occ", convertToPercent(forecastFirstMonth.Occ / noOfDays), ui_state),
        ADR: isNaN(round(forecastFirstMonth.Revenue / forecastFirstMonth.Rooms)) ? "$0.00" :
            dataFormat("ADR", round(forecastFirstMonth.Revenue / forecastFirstMonth.Rooms), ui_state),
        RevPAR: dataFormat("RevPAR", round(forecastFirstMonth.RevPAR / noOfDays), ui_state),
        Revenue: dataFormat("Revenue", Math.round(forecastFirstMonth.Revenue), ui_state),
    };

    let nextMonthDays = moment(startDate).add(1, "month").daysInMonth();
    let nextMonthData = foreCastData.data.data.splice(m, nextMonthDays)
    let forecastNextMonth = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, Revenue: 0 };
    nextMonthData.map((item, index) => {
        forecastNextMonth.Rooms += parseInt(item.predicted_total_cons_rooms);
        forecastNextMonth.Occ += parseFloat(item.predicted_total_cons_occ);
        forecastNextMonth.ADR += parseFloat(item.predicted_total_cons_adr);
        forecastNextMonth.RevPAR += parseFloat(item.predicted_total_cons_revpar);
        forecastNextMonth.Revenue += parseFloat(item.predicted_total_cons_revenue);
    })

    forecastNextMonth = {
        ...forecastNextMonth,
        Rooms: dataFormat("Rooms", forecastNextMonth.Rooms, ui_state),
        Occ: dataFormat("Occ", convertToPercent(forecastNextMonth.Occ / nextMonthDays), ui_state),
        ADR: isNaN(round(forecastNextMonth.Revenue / forecastNextMonth.Rooms)) ? "$0.00" :
            dataFormat("ADR", round(forecastNextMonth.Revenue / forecastNextMonth.Rooms), ui_state),
        RevPAR: dataFormat("RevPAR", round(forecastNextMonth.RevPAR / nextMonthDays), ui_state),
        Revenue: dataFormat("Revenue", Math.round(forecastNextMonth.Revenue), ui_state),
    };

    // far month data 
    let farMonthDays = moment(startDate).add(2, "month").daysInMonth();
    let farMonthData = foreCastData.data.data.splice((m), farMonthDays)

    let forecastFarMonth = { Rooms: 0, Occ: 0, ADR: 0, RevPAR: 0, Revenue: 0 };
    farMonthData.map((item, index) => {
        forecastFarMonth.Rooms += parseInt(item.predicted_total_cons_rooms);
        forecastFarMonth.Occ += parseFloat(item.predicted_total_cons_occ);
        forecastFarMonth.ADR += parseFloat(item.predicted_total_cons_adr);
        forecastFarMonth.RevPAR += parseFloat(item.predicted_total_cons_revpar);
        forecastFarMonth.Revenue += parseFloat(item.predicted_total_cons_revenue);
    })

    forecastFarMonth = {
        ...forecastFarMonth,
        Rooms: dataFormat("Rooms", forecastFarMonth.Rooms, ui_state),
        Occ: dataFormat("Occ", convertToPercent(forecastFarMonth.Occ / farMonthDays), ui_state),
        ADR: isNaN(round(forecastFarMonth.Revenue / forecastFarMonth.Rooms)) ? "$0.00" :
            dataFormat("ADR", round(forecastFarMonth.Revenue / forecastFarMonth.Rooms), ui_state),
        RevPAR: dataFormat("RevPAR", round(forecastFarMonth.RevPAR / farMonthDays), ui_state),
        Revenue: dataFormat("Revenue", Math.round(forecastFarMonth.Revenue), ui_state),
    };
    console.log("forecastFarMonth => ", forecastFarMonth);
    let dataObj = [forecastFirstMonth, forecastNextMonth, forecastFarMonth];
    return dataObj;
}

export function generatDailyFlashChartOptions(displayData,
    { reportType, identifiers, measures, data_id, ui_state }) {
    const chartColors = deepCopy(CHART_OPTIONS.COLORS.dailyFlash);
    const options = deepCopy(CHART_OPTIONS.dailyFlash);
    const active_api = 'OSR';
    // debugger;
    //series is the set od data points for a line/column, initial measures will check the measures input to create the data sets
    let tile_id = reportType;
    const { data_sources } = TILES['daily_flash'];
    const chartConfig = { mainkey: 'aggregates', xAxisKey: 'monthData' };
    const series = [];

    // Setting up default measures
    let intialMeasures = [measures[0], measures[1]];

    //As no pre defined identifiers is there for compset and it depends on compset names in API response

    // debugger;  
    //setting name is important for colors
    let seriesLabel = '';
    seriesLabel = capitalizeFirstLetter(tile_id);
    if (tile_id === 'otb' || tile_id === 'pickup') {
        seriesLabel = 'OTB'
    }
    let seriesName = '';

    const category = active_api + seriesLabel;
    let setYAxis = true;
    const yAxisArr = [];

    // debugger;
    // options.xAxis.min = new moment().startOf('month').format('x');
    // options.xAxis.max = moment().add(3, 'month').format('x');
    options.xAxis[0].type = 'category';
    // options.xAxis[0].labels.formatter = function () {
    //     let d = this.value;
    //     return new moment(this.value).format("MMM");
    // }
    identifiers.map((identifier, identifierIndex) => {
        seriesName = identifier
        if (identifier === 'primary') {
            seriesName = seriesLabel
        }
        if (identifier === 'pickup') {
            seriesName = seriesLabel
        }
        if (["sdly_actual", "sdtly_actual"].includes(identifier)) {
            seriesName = "LY ACTUAL";
        }
        if (["sdly", "sdtly"].includes(identifier)) {
            //seriesName = "SDLY";
            
        }
        seriesName = seriesName.split('_').join(' ');

        // debugger 
        //only setting y-axis in first iteration of identifiers
        if (identifierIndex == 1) { setYAxis = false; }

        intialMeasures.map((measure, measureIndex) => {
            // debugger;

            if (measure) {
                let color_key = measureIndex ? tile_id + '_' + identifier + '_R' : tile_id + '_' + identifier + '_L';
                color_key = color_key.toUpperCase();
                let seriesLabel = measure + ' ' + identifier.split('_').join(' ').toUpperCase();
                if (identifier === 'primary' || identifier === 'pickup') {
                    seriesLabel = measure + ' ';
                    if (measure === 'Occ') {
                        seriesLabel = measure + '% ';
                    }
                } else {
                    if (["sdly_actual", "sdtly_actual"].includes(identifier)) {
                        seriesLabel = measure + ' ' + seriesName;
                        if (measure === 'Occ') {
                            seriesLabel = measure + '% ' + seriesName;
                        }
                    }else if (measure === 'Occ') {
                        seriesLabel = measure + '% ' + identifier.split('_').join(' ').toUpperCase();
                    }
                }

                if (seriesLabel.indexOf('SDTLY') > -1) {
                    // seriesLabel = seriesLabel.replaceAll('SDTLY', 'SDLY');
                }
                
                const seriesConfig = {
                    "data": [],
                    "name": seriesLabel,
                    "id": seriesLabel + '_' + identifier + '_' + measure + '_' + measureIndex,
                    "color": chartColors[color_key],
                    "colorKey": color_key,
                    "currency": { code: ui_state.currency, symbol: ui_state.currency_symbol },
                    "dataGrouping": {
                        "units": [
                            [
                                "month",
                                [
                                    1
                                ]
                            ]
                        ],
                        "enabled": false
                    },
                    "type": 'column',
                    "negativeColor": "#FF0000",
                    "yAxis": "",
                    "category": category,
                    "seriesName": seriesName,
                    "mainMeasure": measure,
                    "subCategory": "",
                    "stack": seriesName + "_" + measureIndex
                }
                //Do some different for Occ measure
                if (measure === "Occ") {
                    seriesConfig["mainMeasure"] = measure + "%";
                }
                //first measure should always be in column form with light blue
                // debugger;
                if (measureIndex === 0) {
                    seriesConfig["yAxis"] = "primaryYAxis" + measure;
                    seriesConfig["zIndex"] = 1

                    if (measure === "Occ") {
                        seriesConfig["yAxis"] = "primaryYAxis" + measure + "%";
                    }
                }
                //otherwise second measure should be line/lines
                else {
                    seriesConfig["yAxis"] = "secondaryRightYAxis" + measure;
                    seriesConfig["type"] = 'spline';
                    seriesConfig["zIndex"] = 2
                    if (measure === "Occ") {
                        seriesConfig["yAxis"] = "secondaryRightYAxis" + measure + "%";
                    }

                }

                //code for setting y-axis
                if (setYAxis) {
                    const yAxisConfig = {
                        "id": "",
                        "title": {
                            "text": "",
                            "style": {
                                "color": "#606060",
                                "fontFamily": "Lato Regular"
                            },
                            "useHTML": true,
                            // "align": "high",
                            // "offset": 0,
                            // "rotation": 0
                        },
                        "opposite": false,
                        "labels": {
                            "style": {
                                "color": "#606060",
                                "fontFamily": "Lato Regular"
                            }
                        },
                        "crosshair": {
                            "width": 1,
                            "color": "rgb(130,203,208)"
                        },
                        "endOnTick": true,
                        "showLastLabel": true,
                        "maxPadding": 0.25,

                    };
                    yAxisConfig["id"] = seriesConfig.yAxis;

                    if (measureIndex == 0) {

                        yAxisConfig["plotLines"] = [
                            {
                                "value": 100,
                                "color": "black",
                                "dashStyle": "shortdash",
                                "width": 2,
                                "label": {
                                    "text": ""
                                }
                            }
                        ]
                    } else {
                        yAxisConfig["gridLineColor"] = "transparent";
                        yAxisConfig["opposite"] = true;

                    }
                    options.yAxis.push(yAxisConfig);
                }

                //setting data from identifier and measure into data to graph
                if (displayData.length) {
                    let chartData = generateChartData(displayData, { chartConfig, identifier, measure, data_id, ui_state });
                    seriesConfig.data = chartData;
                }

                //seriesConfig["data"].sort((a,b) => a.x - b.x)
                seriesConfig['marker'] = { enabled: false };
                // seriesConfig.visible = true;
                seriesConfig.showInLegend = true;

                //Setting colors for the chart curves/columns
                let seriesConfigNew = { ...seriesConfig };
                options.series.push(seriesConfigNew);
            }
        })
    });
    // debugger;

    return options;
}
const generateChartData = (displayData, params) => {
    // debugger;
    const size = displayData.length;
    const { chartConfig, identifier, measure, data_id } = params;
    const { xAxisKey, mainkey } = chartConfig;
    let data = [];
    for (let index = 0; index < size; index++) {
        const dataItem = displayData[index];
        let dataObj = null;
        let xValue = 0;
        let yValue = 0;
        let xKey = xAxisKey;
        //Handle dates
        const month = dataItem[xKey];
        // debugger;
        let tooltipLabel = dataItem[xKey];
        xValue = Number(new moment(month).startOf('month').format('x'));
        // debugger 

        if (mainkey) {
            dataObj = dataItem[mainkey];
        }

        if (dataObj && dataObj[identifier] && dataObj[identifier][measure]) {
            yValue = round(dataObj[identifier][measure]);
            //Handle Occ differently
            if (measure === "Occ") {
                yValue = round(dataObj[identifier][measure] * 100);
            }
        }
        // data.push({ "x": month, "y": yValue, "tooltipLabel": tooltipLabel });
        // debugger
        data.push([month.split(',')[0], yValue, tooltipLabel]);

    }
    // debugger;
    return data;
};


// function for download report 


export function downloadReportToExcelx(app_state, ui_state, selectedPropertyName, data) {
    console.log("data and clicked =>", data);

    let exportFileName = moment(app_state.as_of_date).format('MMM DD YYYY') + "_" + selectedPropertyName + "_DailyFlash";
    if (data && data.length > 0) {
        console.log("data and clicked =>", data);
        TableToExcel.convert(document.getElementById("dailyFlashTable"), {
            name: exportFileName + ".xlsx",
            sheet: {
                name: "Daily Flash Report"
            }
        });
    }
}




